import React, { Fragment } from 'react';

import './CollegeExchangeFundListActionBarLink.scss';

const CollegeExchangeFundListActionBarLink = () => (
  <Fragment>
    <span className="college-exchange-fund-list-action-bar-link-call-to-action">
      Looking to expand your investment options?
    </span>
    Add a new portfolio for an existing beneficiary.
  </Fragment>
);

export default CollegeExchangeFundListActionBarLink;
